<template>
  <div>
    <div>
      <base-header class="pb-6 pb-8 pt-5 pt-md-8 bg-gradient-primary">
        <!-- Card stats -->
        <b-row> </b-row>
      </base-header>
      <b-container fluid class="mt--7">
        <b-row class="justify-content-center">
          <b-col lg="12">
            <card header-classes="bg-transparent">
              <b-row class="mb-4">
                <b-col lg="10" md="12" class="d-flex align-items-center mb-4">
                  <h2 slot="header" class="mb-0">จัดการราคางาน</h2>
                </b-col>
                <b-col lg="2" md="12" class="text-right">
                  <base-button
                    type="primary"
                    class=""
                    block
                    @click="
                      $router.push({
                        name: 'createRate',
                      })
                    "
                  >
                    สร้างราคางาน
                  </base-button>
                </b-col>
              </b-row>
              <b-row class="justify-content-end">
                <b-col lg="4" md="12" class="mb-2">
                  <b-form-input
                    v-model="searchTerm"
                    @input="onSearchInput"
                    placeholder="ค้นหา"
                  ></b-form-input>
                </b-col>
              </b-row>
              <hr class="my-3" />
              <b-row class="mb-4">
                <b-col>
                  <b-table
                    striped
                    responsive
                    hover
                    :fields="fields"
                    :items="items"
                    :busy="isLoading"
                    class="custom-table"
                  >
                    <template #cell(index)="data">
                      {{
                        calculateIndex(
                          data,
                          pagination.currentPage,
                          pagination.perPage
                        )
                      }}
                    </template>
                    <template #table-busy>
                      <div class="text-center text-danger my-2">
                        <b-spinner class="align-middle"></b-spinner>
                      </div>
                    </template>
                    <template #cell(customers)="data">
                      <div class="fix-content-100">
                        {{
                          data.item.customers.length > 0
                            ? data.item.customers
                                .map((customer) => customer.f_name)
                                .join(", ")
                            : "-"
                        }}
                      </div>
                    </template>
                    <template #cell(vehicle_type)="data">
                      {{ data.item.vehicle_type.name }}
                    </template>

                    <template #cell(manage)="data">
                      <b-button
                        variant="outline-success"
                        size="sm"
                        @click="
                          $router.push({
                            name: 'manageRateId',
                            params: { id: data.item.id },
                          })
                        "
                      >
                        <b-icon icon="eye-fill"></b-icon>
                      </b-button>
                      <b-button variant="outline-danger" size="sm" disabled>
                        <b-icon icon="trash-fill"></b-icon>
                      </b-button>
                    </template>
                  </b-table>
                </b-col>
              </b-row>
              <b-row>
                <b-col class="d-flex justify-content-end">
                  <b-pagination
                    v-model="pagination.currentPage"
                    :disabled="isLoading"
                    :total-rows="pagination.totalRows"
                    :per-page="pagination.perPage"
                    aria-controls="my-table"
                    class="mt-3"
                    @change="(page) => getRate(page)"
                  ></b-pagination>
                </b-col>
              </b-row>
            </card>
          </b-col>
        </b-row>
      </b-container>
    </div>
  </div>
</template>
<script>
import calculateIndex from "@/util/calculateIndex.js";
import rateServices from "@/api/rate.service.js";
import createDebouncedFunction from "@/util/debounce.js";
import { getCancelToken } from "@/util/axiosCancel";
export default {
  props: {},
  data() {
    return {
      calculateIndex,
      isLoading: false,
      searchTerm: "",
      pagination: {
        currentPage: 1,
        perPage: 10,
        rows: 0, // จำนวนข้อมูลทั้งหมด
      },
      items: [],
      fields: [
        {
          key: "index",
          label: "#",
        },
        {
          key: "id",
          label: "รหัสเรทราคา",
        },
        {
          key: "vehicle_type",
          label: "ประเภทรถ",
        },
        {
          key: "name",
          label: "ชื่อเรทราคา",
        },
        {
          key: "customers",
          label: "รายชื่อลูกค้า",
        },
        {
          key: "manage",
          label: "การจัดการ",
        },
      ],
    };
  },
  created() {
    this.getRate();
  },
  methods: {
    onSearchInput: createDebouncedFunction(function() {
      this.getRate();
    }, 500),
    async getRate(page = 1) {
      this.isLoading = true;
      try {
        const cancelToken = getCancelToken();
        const response = await rateServices.getRate(
          {
            page,
            search: this.searchTerm,
          },
          cancelToken
        );
        this.items = response.data.data.items;
        this.pagination.totalRows = response.data.data.meta.totalItems;
        this.pagination.perPage = response.data.data.meta.itemsPerPage;
        this.pagination.currentPage = response.data.data.meta.currentPage;
        this.isLoading = false;
      } catch (error) {}
    },
  },
  mounted() {},
};
</script>
